module.exports = __webpack_public_path__ + "img/buttonicon2.32a6676c.png";